module.exports = __webpack_public_path__ + "img/randabstand-EC2-ansicht.638089fd.png";